'use client';

import { cn } from '@/lib/utils';
import { FeatureNote, VillageFeature } from '@/services/types';
import { useState } from 'react';
import './styles.css';
import { IVillageDictionary } from '@/dictionaries/pages/village/types';
import Accordion from '../Accordion';
import translateFromArray from '@/utils/get-translated-object';

type Props = {
  dict: IVillageDictionary;
  villageFeatures: VillageFeature[];
  lang: string;
};

export default function AmenitiesOutdoorContent({
  dict,
  villageFeatures,
  lang,
}: Props) {
  const [isOpen, setIsOpen] = useState(true);
  const outdoorFeatures = villageFeatures.filter(
    ({ feature }) => feature.type == 'outdoor',
  );
  const { amenities } = dict;

  let noteCounter = 1;

  const outdoorContent: FeatureNote[] = [];

  const contentNotes: FeatureNote[] = [];

  outdoorFeatures.forEach(({ feature, translations }) => {
    const translation = translateFromArray({
      lang,
      translations: feature.featureTranslation,
    });

    const hasNotes = translations.length > 0;
    const noteTranslation = translateFromArray({ lang, translations });

    if (hasNotes && noteTranslation?.note) {
      const featureWithNote = {
        description: translation?.title || '',
        noteNumber: noteCounter,
      };

      outdoorContent.push(featureWithNote);

      contentNotes.push({
        description: noteTranslation?.note,
        noteNumber: featureWithNote.noteNumber,
      });
      noteCounter++;
    } else {
      outdoorContent.push({
        description: translation?.title || '',
        noteNumber: undefined,
      });
    }
  });

  return (
    <div className="py-[20px]">
      <Accordion
        label={amenities.outdoor}
        isOpen={isOpen}
        toggle={() => setIsOpen(!isOpen)}>
        <div className="block">
          <div className="flex flex-wrap">
            <div className="w-full flex-[0_0_auto] desktop:w-3/4 desktop:ml-[25%]">
              <div className="desktop-column columns-1 pt-[32px]">
                <ul className="ml-0 list-none mb-4 leading-[1.6]">
                  {outdoorContent.map((content) => (
                    <li className="mb-2" key={content.description}>
                      <span>{content.description}</span>
                      {content.noteNumber && (
                        <sup className="text-xs text-blue ml-1">
                          {content.noteNumber}
                        </sup>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-8">
                {contentNotes.map((note) => (
                  <p key={note.noteNumber}>
                    <span className="text-xs text-blue mr-1">
                      {note.noteNumber}
                    </span>
                    <span className="text-xs text-gray-700">
                      {note.description}
                    </span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  );
}
